var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './buttonSelectList.module.scss';
import { Button, EButtonType } from '../../button/Button';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { onClickOutside } from 'src/shared/helpers/viewsHelpers';
import { E_SELECT_SHORTCUTS } from 'src/ui/components/Input/Select/constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { IDENTIFIER_BUTTON_SELECT, IDENTIFIER_BUTTON_SELECT_OPTION_ITEM, IDENTIFIER_BUTTON_SELECT_OPTION_SHORTCUT, IDENTIFIER_BUTTON_SELECT_OPTIONS, } from 'src/ui/components/Input/ButtonSelectList/constants';
export var ButtonSelectList = function (props) {
    var _a;
    var i18n = props.i18n, _b = props.type, type = _b === void 0 ? EButtonType.NEUTRAL : _b, isEdge = props.isEdge, label = props.label, options = props.options, multiple = props.multiple, _c = props.value, value = _c === void 0 ? [] : _c, className = props.className, leftIcon = props.leftIcon, withShortcut = props.withShortcut, defaultValueProps = props.defaultValue, identifier = props.identifier, onChange = props.onChange;
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = useState(E_SELECT_SHORTCUTS.DEFAULT), currentShortcut = _e[0], setCurrentShortcut = _e[1];
    var optionsWrapperRef = useRef(null);
    var defaultValue = useRef(defaultValueProps || value);
    useMount(function () {
        onClickOutside(optionsWrapperRef, function () { return setIsOpen(false); });
    });
    var handleOnChange = function (newValue) {
        var isExist = Array.isArray(value) ? value.indexOf(newValue) !== -1 : value === newValue;
        if (multiple) {
            var values = isExist ? value.filter(function (val) { return val !== newValue; }) : __spreadArray(__spreadArray([], value, true), [newValue], false);
            onChange(values);
        }
        else {
            onChange(isExist ? null : newValue);
        }
    };
    var handleOpenOptions = function () {
        setIsOpen(!isOpen);
    };
    var selectWrapperClassName = classNames(styles.selectWrapper, className);
    var optionsWrapperClassName = classNames(styles.optionsWrapper, (_a = {},
        _a[styles.optionsWrapperOpen] = isOpen,
        _a));
    var optionClassName = function (isSelected) {
        var _a;
        return classNames(styles.optionItem, (_a = {}, _a[styles.optionItemSelected] = isSelected, _a));
    };
    var handleShortcutClick = function (e) {
        e.stopPropagation();
        switch (currentShortcut) {
            case E_SELECT_SHORTCUTS.DEFAULT: {
                setCurrentShortcut(E_SELECT_SHORTCUTS.ALL);
                return onChange(options);
            }
            case E_SELECT_SHORTCUTS.ALL: {
                setCurrentShortcut(E_SELECT_SHORTCUTS.NONE);
                return onChange([]);
            }
            case E_SELECT_SHORTCUTS.NONE: {
                setCurrentShortcut(E_SELECT_SHORTCUTS.DEFAULT);
                return onChange(defaultValue.current);
            }
        }
    };
    var getShortcutLabel = function () {
        switch (currentShortcut) {
            case E_SELECT_SHORTCUTS.DEFAULT: {
                return getPropsByKeyPath(i18n.keyValueMap, 'select.all');
            }
            case E_SELECT_SHORTCUTS.ALL: {
                return getPropsByKeyPath(i18n.keyValueMap, 'select.none');
            }
            case E_SELECT_SHORTCUTS.NONE: {
                return getPropsByKeyPath(i18n.keyValueMap, 'select.default');
            }
        }
    };
    var buttonIdentifier = identifier ? identifier : IDENTIFIER_BUTTON_SELECT;
    return (_jsxs("div", __assign({ "data-test": buttonIdentifier, className: selectWrapperClassName, ref: optionsWrapperRef }, { children: [_jsx(Button, { label: label, type: type, isEdge: isEdge, classname: styles.buttons, leftIcon: leftIcon, onClick: handleOpenOptions }), _jsxs("ul", __assign({ "data-test": IDENTIFIER_BUTTON_SELECT_OPTIONS, className: optionsWrapperClassName }, { children: [withShortcut && multiple && (_jsxs(_Fragment, { children: [_jsx("li", __assign({ "data-test": IDENTIFIER_BUTTON_SELECT_OPTION_SHORTCUT, className: classNames(styles.optionItem, styles.shortcutItem), onClick: handleShortcutClick }, { children: getShortcutLabel() })), _jsx("li", { className: styles.shortcutItemSeparator })] })), options.map(function (opt) {
                        var isSelected = Array.isArray(value) ? value.indexOf(opt) !== -1 : value === opt;
                        return (_jsx("li", __assign({ "data-test": IDENTIFIER_BUTTON_SELECT_OPTION_ITEM, className: optionClassName(isSelected), onClick: function () { return handleOnChange(opt); } }, { children: opt }), opt));
                    })] }))] })));
};
